<template>
  <page :title="pageTitle">
    <page-header :title="pageTitle" />
    <page-content>
      <rest-list :payload="fetchEndpoint" ref="list" :filterable="false">
        <rest-list-column
          prop="category"
          :title="$t('QueueStatusPage_Field_Category')"
        />

        <rest-list-column
          prop="action"
          :title="$t('QueueStatusPage_Field_Action')"
        />

        <rest-list-column
          prop="source"
          :title="$t('QueueStatusPage_Field_Source')"
        />

        <rest-list-column
          prop="items"
          :title="$t('QueueStatusPage_Field_Items')"
          :formatter="itemsFormatter"
        />

        <rest-list-column
          prop="delay"
          :title="$t('QueueStatusPage_Field_Delay')"
          :formatter="delayFormatter"
        />

        <rest-list-column
          prop="isolation"
          :title="$t('QueueStatusPage_Field_Isolation')"
        />
      </rest-list>
    </page-content>
  </page>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint, formatNumber } from '@/core/helpers'
import Page from '../../../common/components/page/Page.vue'
import PageHeader from '../../../common/components/page/PageHeader.vue'
import PageContent from '../../../common/components/page/PageContent.vue'
import RestList from '../../../common/components/rest/RestList.vue'

export default {
  components: {
    RestList,
    PageContent,
    PageHeader,
    Page,
    RestListColumn
  },

  data() {
    return {
      refreshInterval: null
    }
  },

  mounted() {
    this.refreshInterval = setInterval(() => {
      this.$refs['list'].refresh()
    }, 5000)
  },

  destroyed() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },

  methods: {
    itemsFormatter(value) {
      return formatNumber(value) + ' items'
    },

    delayFormatter(value) {
      return formatNumber(Math.floor(value / 60)) + ' minutes'
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `system/queue/status`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/system/pages/QueueStatusPage.vue